<template>
    <v-list-item>
        <v-list-item-avatar size="48" class="mt-0">
            <v-img :href="'/users/' + comment.user.id" :src="comment.user.avatar" class="e-link" v-ripple></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
            <v-list-item-title class="d-flex justify-lg-space-between flex-column flex-lg-row">
                {{comment.user.name}}
            </v-list-item-title>
            <v-list-item-subtitle class="text--text" style="white-space: pre-line;"> {{text}} <a v-if="longText && !showMore" class="blue--text text--darken-3" @click.prevent="showMore = true;">عرض المزيد</a> <a v-if="longText && showMore" class="blue--text text--darken-3" @click.prevent="showMore = false;">عرض أقل</a></v-list-item-subtitle>

            <v-tooltip transition="fade-transition" color="tooltip" bottom>
                <template v-slot:activator="{on, attrs}">
                    <div v-on="on" v-bind="attrs" >
                        <!-- <v-chip label color="surface2" small class="px-2 text--text" style="font-size: 11px; height: 20px;">{{timeFormat(comment.created_at, true)}}</v-chip> -->
                        <span class="muted--text" style="font-size: 11px">{{timeFormat(comment.created_at, true)}}</span>
                    </div>
                </template>
                <div class="ltr-dir">
                    {{dateTimeFormat(comment.created_at, true)}}
                </div>
            </v-tooltip>
        </v-list-item-content>
    </v-list-item>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
export default {
    props: {
        comment: {}
    },
    data(){
        return {
            showMore: false,
        }
    },
    computed: {
        ...GlobalComputed,
        longText(){
            const text = this.comment.text;
            return text.length > 800;
        },
        text(){
            const text = this.comment.text;
            return this.longText && !this.showMore ? text.slice(0, 800) + '...' : text;
        }
    },
    methods: {
        ...GlobalMethods,
    }
}
</script>

<style lang="scss" scoped>

</style>
